import { put, call, take, fork } from 'redux-saga/effects'
import { LLMGetTranslatedContentService } from '../../api/llm'
import { llmGetTranslatedContentSuccess } from '../../reducers/llm/action'
import { GET_TRANSLATED_CONTENT } from 'src/reducers/llm/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* getTranslatedChatContentFlow(payload) {
  try {
    const { content, languageCode, courseType, callback } = payload

    const response = yield call(
      LLMGetTranslatedContentService,
      content,
      languageCode,
      courseType,
    )

    yield put(llmGetTranslatedContentSuccess(response))
    yield put(operationSuccess())

    callback(response)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* getTranslatedChatContentWatcher() {
  while (true) {
    const action = yield take(GET_TRANSLATED_CONTENT)
    const { payload } = action

    yield fork(generalSaga, getTranslatedChatContentFlow, payload, false)
  }
}
